/**
 * @generated SignedSource<<3657923547352dcaf04f9048202e36b7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TimeSlotListInternalServerTimeQuery$variables = Record<PropertyKey, never>;
export type TimeSlotListInternalServerTimeQuery$data = {
  readonly currentServerTime: string;
};
export type TimeSlotListInternalServerTimeQuery = {
  response: TimeSlotListInternalServerTimeQuery$data;
  variables: TimeSlotListInternalServerTimeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "currentServerTime",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "TimeSlotListInternalServerTimeQuery",
    "selections": (v0/*: any*/),
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "TimeSlotListInternalServerTimeQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "fe97ef4589e88e35a532db2451e32ea2",
    "id": null,
    "metadata": {},
    "name": "TimeSlotListInternalServerTimeQuery",
    "operationKind": "query",
    "text": "query TimeSlotListInternalServerTimeQuery {\n  currentServerTime\n}\n"
  }
};
})();

(node as any).hash = "5feb73cd56d661ac7e88781096ee6710";

export default node;
